import { useLastPathSegment } from 'shared/hooks'
import { useBuyNumberStepsContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/context/useBuyNumberStepsContext'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useBuyNumberStepsContext()

  return getProgressInfoTitle(useLastPathSegment())
}
